
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SessionNote')
export class SessionNote {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('name', String, true)
    name = '';

    @JsonProperty('name_ar', String, true)
    nameAr = '';

    get noteStr() {
        return this.nameAr || this.name;
    }
}